export const LOCATION_API_01 = "Locations/getlocations";

export const LOCATION_API_02 = "Locations/CreateLocation";

export const FILE_API_01 = "Fileupload/upload";

export const COUNTRY_API = "Syscommon/getcountries";

export const CURRENCY_API = "Syscommon/getCurrencyDetails";

export const USERGROUP_API_01 = "Usergroups/getusergroups";

export const USERGROUP_API_02 = "Usergroups/CreateGroup";

export const USERGROUP_API_03 = "Privileges/getmappedpriviledges";

export const USERGROUP_API_04 = "Privileges/getgrouppriviledges";

export const USERGROUP_API_05 = "Syscommon/getmodules";

export const USERGROUP_API_06 = "Privileges/mapmodules";

export const COMPANY_API_01 = "Account/getcompany";

export const COMPANY_API_02 = "Account/UpdateAccount";

export const MAPLOCATION_API_01 = "Users/getMapLocationUser";

export const MAPLOCATION_API_02 = "Users/CreateMapLocationUsers";

export const USERS_API_01 = "Usergroups/getusers";

export const LICENSE_API_01 = "License/getcompanylicense";
export const LICENSE_API_02 = "License/getcompanyduepayments";
export const LICENSE_API_03 = "License/getinvoicedetails";
export const LICENSE_API_04 = "License/getaddonsforclientpackageupdate";
export const LICENSE_API_05 = "License/getlicenseforclientpackageupdate";
export const LICENSE_API_06 = "License/getlicenseforclientpackageupdate";
export const LICENSE_API_07 = "License/getlicenseforclientpackageupdate";

export const PARAMETER_API_01 = "Parameters/getUserParameters";
export const PARAMETER_API_02 = "Parameters/getSystemStatus";
export const PARAMETER_API_03 = "Parameters/createParameters";
export const USERS_CREATE_USER_API = "Users/CreateUser";
export const USERS_COMPANY_USERS_API = "Users/getcompanyusers";

export const USERS_EMAIL_SETUP_API_01 = "Emailsetup/getemailactionlist";

export const USERS_EMAIL_SETUP_API_02 = "Emailsetup/getsetupemails";
export const USERS_EMAIL_SETUP_API_03 = "Emailsetup/postsetupemail";

export const USERS_SMS_SETUP_API_01 = "Smssetup/getsmsactionlist";

export const USERS_SMS_SETUP_API_02 = "Smssetup/getsetupsms";
export const USERS_SMS_SETUP_API_03 = "Smssetup/postsetupsms";

export const Dayend_API_02 = "Locations/ProcessDayend";

export const USERS_API_04 = "Users/UpdateUser";
export const USERS_API_05 = "Users/getUserAccount";
export const USERS_API_06 = "Users/getUseraccountLog";
export const USERS_API_07 = "Users/Changepassword";
export const USERS_API_08 = "Users/CreateMapLocationUsers";
export const USERS_API_09 = "Users/getUserAccount";
export const USERS_API_10 = "Login/Clearsession";
export const USERS_API_11 = "Users/validaeOldpassword";
export const USERS_API_12 = "Users/getUserAuditLog";

export const REPORTS_API_01 = "Reports/getmapreports";
export const REPORTS_API_02 = "Reports/mapusergroupreports";

export const TAX_API_01 = "Tax/gettaxtypes";
export const TAX_API_02 = "Tax/createtaxtype";
export const TAX_API_03 = "Tax/gettaxappliedpages";
export const TAX_API_04 = "Tax/gettaxseq";
export const TAX_API_05 = "Tax/createtaxtypesequence";

export const CURRENCY_API_01 = "Currency/getcurrencymap";
export const CURRENCY_API_02 = "Currency/getcurrencydetails";
export const CURRENCY_API_03 = "Currency/createcurrencymap";

export const PAYMENT_API_01 = "Payment/getpaymentoptions";
export const PAYMENT_API_02 = "Payment/getmappedpaymentoptions";
export const PAYMENT_API_03 = "Payment/createpaymentoptions";
export const PAYMENT_API_04 = "Payment/getmappedpaymentoptions";

export const SHOP_API_01 = "Shop/getstores";
export const SHOP_API_02 = "Shop/createstore";
export const SHOP_API_03 = "Shop/getstorebusinesstypes";
export const SHOP_API_04 = "Shop/getStoreUsers";
export const SHOP_API_05 = "Shop/mapstoreuser";

export const SHOPQR_API_01 = "Shop/createstoreqrcode";
//API List







// Login API (Post API)
export const LOGIN_API = "Login/Login";
export const LOGOUT_API = "Login/Logout";
export const LOGIN_API_2 = "Login/Transferlogin";





